import { render } from "./FormSagepayments.vue?vue&type=template&id=f2259408&scoped=true"
import script from "./formsagepayments.view.js?vue&type=script&lang=js&external"
export * from "./formsagepayments.view.js?vue&type=script&lang=js&external"

import "./formsagepayments.css?vue&type=style&index=0&id=f2259408&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2259408"]])

export default __exports__